import React, {ReactElement} from 'react';
import './About.css';

function About(props: {}): ReactElement {
    return html;
}

const html: ReactElement =
    <>
        <div className="text-2xl font-light text-500 mb-4">
            About Me
        </div>
        <div className="flex flex-column about-content">
            <div className="text-lg mb-4 flex flex-column align-items-center">
                <span className="material-symbols-outlined">mail</span>
                <a href="mailto:anabel.olguin@gmail.com" className="no-underline hover:underline text-700">anabel.olguin@gmail.com</a>
            </div>
            <div className="text-lg">
                Anabel is a San Diego based costume designer originally from Phoenix, AZ. She earned her Master of Fine Arts in Costume Design from the University of California San Diego in 2025. Before turning her focus on costume design, she received a Bachelor of Arts in Theatre Education from Grand Canyon University, and dedicated 7 years as a full time theatre educator. During this time, Anabel was also an active member of the Phoenix theatre community where she worked as a director, sound designer, stage manager, props designer, scenic designer, and performer. Anabel currently works as a Resident Costume Design Assistant at The Old Globe Theatre.
            </div>
        </div>
    </>

export default About;
